<template>
  <div v-if="isVisible" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="bg-white rounded-lg p-6 max-w-md w-full mx-4">
      <div class="flex items-center space-x-3 mb-4">
        <span class="material-symbols-outlined text-red-600 text-2xl">warning</span>
        <h3 class="text-lg font-semibold text-gray-900">Cancel Subscription</h3>
      </div>
      
      <p class="text-gray-600 mb-6">
        Are you sure you want to cancel your subscription? <b>You will immediately lose access to premium features and be downgraded to the Free plan.</b>
        <br>
        <span class="text-xs text-gray-500">
          Tip: For best value, consider cancelling a day before your renewal date ({{ formatDate(profile?.plan?.renewsAt) }}).
        </span>
      </p>
      
      <div class="flex space-x-3">
        <button 
          @click="handleKeep"
          class="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
        >
          Keep Subscription
        </button>
        <button 
          @click="handleConfirm"
          :disabled="loading"
          class="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:opacity-50"
        >
          {{ loading ? 'Cancelling...' : 'Yes, Cancel' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CancelSubscriptionModal',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    profile: {
      type: Object,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close', 'confirm'],
  methods: {
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return '';
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    },

    handleKeep() {
      this.$emit('close');
    },

    handleConfirm() {
      this.$emit('confirm');
    }
  }
};
</script>
